import React from 'react'

import {
  SingleColumnLayout,
  SingleColumnLayoutProps,
} from '../SingleColumnLayout'
import { Container, LeftColumn, RightColumn } from './styles'

const TWO_COL_MAX_WIDTH = 1024 as const

export interface TwoColumnLayoutProps extends SingleColumnLayoutProps {
  tabletFullscreen?: boolean
  leftContent?: React.ReactNode
}

export const TwoColumnLayout = ({
  tabletFullscreen = false,
  leftContent,
  children,
  ...layoutProps
}: TwoColumnLayoutProps) => {
  return (
    <SingleColumnLayout
      {...layoutProps}
      maxWidth={TWO_COL_MAX_WIDTH}
      paddingX={[4, 10]}
      hideTabletHeading={tabletFullscreen}
      hideTabletBreadcrumbs={tabletFullscreen}
      hideTabletFooter={tabletFullscreen}
    >
      <Container>
        <LeftColumn>{leftContent}</LeftColumn>

        <RightColumn tabletFullscreen={tabletFullscreen}>
          {children}
        </RightColumn>
      </Container>
    </SingleColumnLayout>
  )
}
